import {computed, getCurrentInstance} from 'vue'
import {useStore} from 'vuex'
import qs from 'qs'
import {getNavigatorLanguage} from '@/composables/useCommon'

export function setupPluginMixin(app: any) {
  // Setup global properties and methods
  app.config.globalProperties.getNavigatorLanguage = getNavigatorLanguage

  app.mixin({
    methods: {
      translate(value: string, labels: Record<string, any>, key: string | null = null): string {
        if (labels && labels[key] && typeof labels[key][value] === 'string') {
          return labels[key][value]
        } else if (Object.keys(labels || {}).length > 0) {
          return `{ ${key} | ${value} }`
        } else {
          return '~~~~~'
        }
      },
      updateUrlParam(keyword: string, value: any) {
        if (window.history && history.replaceState) {
          let _newAddr = location.origin + location.pathname

          const instance = getCurrentInstance()
          const route = (instance?.proxy as any)?.$route

          if (route && route.query) {
            const items = {...route.query}
            if (value && value !== null) {
              items[keyword] = value
            } else {
              delete items[keyword]
            }
            if (Object.entries(items).length > 0) {
              _newAddr += '?' + qs.stringify(items)
            }
          } else if (value !== '') {
            _newAddr += '?' + keyword + '=' + value
          }
          history.replaceState('', '', _newAddr)
        }
      },
      downloadPdfFile(url: string) {
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        link.parentNode?.removeChild(link)
      }
    },
    setup() {
      const store = useStore()

      const labels = computed(() => store.getters['mymachine/getConcepts'])
      const translatedLabel = computed(() => (conceptKey: string, conceptPath: string) => {
        if (labels.value && labels.value[conceptPath] && typeof labels.value[conceptPath][conceptKey] === 'string') {
          return labels.value[conceptPath][conceptKey]
        } else if (Object.keys(labels.value || {}).length > 0) {
          return `{ ${conceptPath} | ${conceptKey} }`
        } else {
          return '~~~~~'
        }
      })

      return {
        labels,
        translatedLabel
      }
    }
  })
}

export default setupPluginMixin
